import { ProductBlockShopify } from './ProductBlockShopify';

export type { TypeProductBlockShopifyProps } from './types';
export default ProductBlockShopify;
